<template>
 <div>
    <label v-if="label">{{label}}</label>
    <vSelect v-if="!noreduce" 
        :options="paginated" 
        v-model="selection" 
        :reduce="option => option.id"
        @input="select" 
        :disabled="disabled" 
        @search="onSearch" 
        :filterable="filterable" 
        :searchable="searchable" 
        :clearable="clearable" 
        :placeholder="placeholder"
        :selectable="selectable">

        <template v-slot:no-options="{ searching }"> <template v-if="searching">{{$t('item.no_results')}}</template></template>
       
        <template slot="option" slot-scope="option">
            <span :class="option.caption && 'caption'"><b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale='1'></b-icon>{{option.label}}</span>
        </template>
        <template slot="selected-option" slot-scope="option"> 
           <span :class="option.caption && 'caption'">
               <b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale='1'></b-icon>
               <span v-if="option.caption">{{option.caption}}</span>
               <span v-else>{{option.label}}</span>
           </span>
        </template>
        <li v-if="optionsPerPage != 0" slot="list-footer" class="selectlist-pagination">
            <button :disabled="!hasPrevPage" @click="offset -= limit"><b-icon icon="chevron-up" variant="dark" scale="1.2" /></button>
            <button :disabled="!hasNextPage" @click="offset += limit"><b-icon icon="chevron-down" variant="dark" scale="1.2" /></button>
        </li>
    </vSelect>

    <vSelect v-else 
        :options="paginated" 
        v-model="selection" 
        @input="select" 
        :disabled="disabled" 
        @search="onSearch" 
        :filterable="filterable" 
        :searchable="searchable" 
        :clearable="clearable" 
        :placeholder="placeholder">
        <template v-slot:no-options="{ searching }"> <template v-if="searching">{{$t('item.no_results')}}</template></template>
       
        <template slot="option" slot-scope="option">
            <span :class="option.caption && 'caption'"><b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale='1'></b-icon>{{option.label}}</span>
        </template>
        <template slot="selected-option" slot-scope="option"> 
           <span :class="option.caption && 'caption'">
               <b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale='1'></b-icon>
               <span v-if="option.caption">{{option.caption}}</span>
               <span v-else>{{option.label}}</span>
           </span>
        </template>
        <li v-if="optionsPerPage != 0" slot="list-footer" class="selectlist-pagination">
            <button :disabled="!hasPrevPage" @click="offset -= limit"><b-icon icon="chevron-up" variant="dark" scale="1.2" /></button>
            <button :disabled="!hasNextPage" @click="offset += limit"><b-icon icon="chevron-down" variant="dark" scale="1.2" /></button>
        </li>
    </vSelect>




</div>
</template>


<script>
import vSelect from 'vue-select'
export default {
    name: 'SelectList',
    components: { vSelect },
    props: {
        label: { type: String, default: null },
        options: { default: null },
        value: { default: null },
        disabled: { type: Boolean, default: false },
        searchable: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        placeholder: { default: null },
        optionsPerPage: { default: 0 },
        noreduce: { default: null },
        selectable: { type: Function, default: () => true }
    },
    data: function() {
        return {
            selection: '',
            search: '',
            offset: 0,
            limit: this.optionsPerPage,
            filterable: this.optionsPerPage == 0 ? true : false
        }
    },
    computed: {
        filtered() {
            if (Array.isArray(this.options)) {
                return this.options.filter((o) =>
                    o.label.toLocaleLowerCase().includes(this.search.toLocaleLowerCase())
                );
            }
            return [];
        },
        paginated() {
            if (this.optionsPerPage == 0) {
                return this.options;
            }
            return this.filtered.slice(this.offset, this.limit + this.offset);
        },
        hasNextPage() {
            const nextOffset = this.offset + this.limit;
            return Boolean(this.filtered.slice(nextOffset, this.limit + nextOffset).length);
        },
        hasPrevPage() {
            const prevOffset = this.offset - this.limit
            return Boolean(this.filtered.slice(prevOffset, this.limit + prevOffset).length);
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal != oldVal)
                this.selection = newVal;
        }
    },
    methods: {
        select(value) {
            this.$emit('select', value);
        },
        onSearch(query) {
            this.search = query
            this.offset = 0
        }
    },
    created() {
        this.selection = this.value;
    }
}
</script>

<style scoped>
.selectlist-pagination {
    display: flex;
    margin: 0.25rem 0.25rem 0;


    padding: 10px 10px 5px 10px;
    margin: 5px 20px 0px 20px;
    border-top: 1px solid #ccc;
}
.selectlist-pagination button {
   flex-grow: 1; 
   margin: 0 10px;
}
.selectlist-pagination button:hover {
    cursor: pointer;
}
</style>